module.exports = __webpack_public_path__ + "static/media/S1N1.9b7268f7.svg";